import {
	ApolloClient,
	ApolloLink,
	HttpLink,
	InMemoryCache,
} from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { ErrorLink } from '@apollo/client/link/error';
import { RetryLink } from '@apollo/client/link/retry';

const graphqlUrl = import.meta.env.VITE_GRAPHQL_URL ?? '/graphql';

// Error handling link
const errorLink = new ErrorLink(({ error, operation }) => {
	if (CombinedGraphQLErrors.is(error)) {
		error.errors.forEach(({ message, locations, path, extensions }) => {
			// UNAUTHENTICATED on session-check queries is expected (user not logged in)
			if (extensions?.code === 'UNAUTHENTICATED') return;
			console.error(
				`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
				extensions,
			);
		});
	} else {
		console.error(`[Network error ${operation.operationName}]:`, error);
	}
});

// Retry link for failed requests
const retryLink = new RetryLink({
	delay: {
		initial: 300,
		max: Number.POSITIVE_INFINITY,
		jitter: true,
	},
	attempts: {
		max: 3,
		retryIf: (error) => !!error,
	},
});

// HTTP link with credentials
const httpLink = new HttpLink({
	uri: graphqlUrl,
	credentials: 'include',
	fetchOptions: {
		mode: 'cors',
	},
});

// Create Apollo Client with all links
export const apolloClient = new ApolloClient({
	link: ApolloLink.from([errorLink, retryLink, httpLink]),
	cache: new InMemoryCache({
		typePolicies: {
			Query: {
				fields: {
					// Add field policies for pagination, etc.
				},
			},
		},
	}),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'cache-and-network',
			errorPolicy: 'all',
		},
		query: {
			fetchPolicy: 'network-only',
			errorPolicy: 'all',
		},
		mutate: {
			errorPolicy: 'all',
		},
	},
});
